import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import redirector from "../../util/redirector";
import Button from "../common/Button";
import Section from "../common/Section";
import Fieldset from "../common/Fieldset";
import * as layoutActions from "../../actions/layoutActions";

class AfgeslotenPage extends React.Component {
	componentWillMount() {
		this.props.loadLayout('');
	}

	render() {
		return (
			<Section>
				<Fieldset>
					<div className="jumbotron">
						<h1>Simulatiedossiers van vorige jaren kunnen niet meer geopend worden.</h1>
					</div>
				</Fieldset>
				<Fieldset />
			</Section>
		);
	}
}

AfgeslotenPage.propTypes = {
	loadLayout: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadExceptionPageLayout, dispatch)
	};
}
export default connect(null, mapDispatchToProps)(AfgeslotenPage);
